import api from './api'

const url = '/calculate'

export const calculate = async (fundingAmount, startingSalary) =>
  api({
    url: `${url}`,
    method: 'post',
    data: {
      fundingAmount,
      startingSalary
    },
  });